import { BehaviorSubject } from "rxjs";

export const is360Subject = new BehaviorSubject(false);
